import type { ReactNode } from 'react';

export const symbol_turn_sharp_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M258.5-128.63Q250-137.25 250-150v-220q0-24.75 17.63-42.38Q285.25-430 310-430h340v-296l-69 69q-9 9-21 9t-21-9q-9-9-9-21t9-21l120-120q9-9 21-9t21 9l120 120q9 9 9 21t-9 21q-9 9-21 9t-21-9l-69-69v296q0 24.75-17.62 42.37Q674.75-370 650-370H310v220q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
